import { render } from "./boundary.vue?vue&type=template&id=3797ec47"
import script from "./boundary.vue?vue&type=script&lang=js"
export * from "./boundary.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__